import { Stack, Typography, TypographyProps } from '@mui/material';

export interface CompoundHeaderProps {
  heading: React.ReactNode;
  subheading?: React.ReactNode;
  headingProps?: Partial<TypographyProps>;
  subheadingProps?: Partial<TypographyProps>;
  invertLabel?: boolean;
}

export function CompoundHeader({
  heading,
  subheading,
  headingProps = {},
  subheadingProps = {},
  invertLabel = false,
}: CompoundHeaderProps) {
  return (
    <Stack direction={invertLabel ? 'column-reverse' : 'column'} spacing={1}>
      <Typography variant="title-l" {...headingProps}>
        {heading}
      </Typography>
      {subheading && (
        <Typography variant="body-xs" {...subheadingProps}>
          {subheading}
        </Typography>
      )}
    </Stack>
  );
}
